import { Grid } from "@material-ui/core";
import RxTypography from "../RxTypography";
import styles from "./RxTitleSeperator.module.css";

interface RxTitleSeperatorProps {
	label?: string;
	titleLabel?: string;
	className?: string;
	variant?:
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "h5"
		| "h6"
		| "subtitle1"
		| "subtitle2"
		| "body1"
		| "body2"
		| "caption"
		| "button";
	titleVariant?:
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "h5"
		| "h6"
		| "subtitle1"
		| "subtitle2"
		| "body1"
		| "body2"
		| "caption"
		| "button";
}

const RxTitleSeperator = (props: RxTitleSeperatorProps) => {
	return (
		<Grid container spacing={1} className={props.className}>
			{props.label && (
				<>
					<RxTypography
						variant={props.variant ?? "subtitle1"}
						align="center"
						label={props.label}
						className={styles.title}
					/>
					<Grid item xs={12} sm={12}>
						<hr className={styles.centerHr} />
					</Grid>
				</>
			)}
			{props.titleLabel && (
				<>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<RxTypography
								variant={props.titleVariant ?? "h5"}
								align="left"
								color="textPrimary"
								label={props.titleLabel}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<hr />
						</Grid>
					</Grid>
				</>
			)}
		</Grid>
	);
};

export default RxTitleSeperator;
